import React from 'react';
import { Typography, Layout } from 'antd';

const { Title, Paragraph } = Typography;
const { Content } = Layout;

const TermsOfUse = () => {
    return (
        <Layout style={{ padding: '24px', maxWidth: '900px', margin: '0 auto' }}>
            <Content>
                <Typography>
                    <Title>Termos de Uso</Title>
                    <Paragraph><strong>Última atualização:</strong> 13/07/2025</Paragraph>

                    <Paragraph>
                        Bem-vindo ao nosso aplicativo de localização de restaurantes. Ao utilizar este app, você concorda com os Termos de Uso abaixo. Recomendamos a leitura atenta antes de continuar a navegação.
                    </Paragraph>

                    <Title level={3}>1. Aceitação dos Termos</Title>
                    <Paragraph>
                        Ao utilizar o aplicativo, você concorda em cumprir estes Termos de Uso e quaisquer leis e regulamentos aplicáveis. Se você não concordar com estes termos, pedimos que não utilize o aplicativo.
                    </Paragraph>

                    <Title level={3}>2. Funcionalidade do Aplicativo</Title>
                    <Paragraph>
                        Este aplicativo tem como principal função mostrar restaurantes próximos à sua localização atual. Para isso, é necessário permitir o acesso à localização do dispositivo.
                    </Paragraph>
                    <Paragraph>
                        A localização é usada apenas temporariamente, durante o uso do app, e <strong>não é vinculada a dados pessoais nem armazenada de forma identificável</strong>.
                    </Paragraph>

                    <Title level={3}>3. Responsabilidades do Usuário</Title>
                    <Paragraph>
                        Você se compromete a utilizar o aplicativo de forma responsável, não realizando práticas abusivas ou ilegais, nem tentando acessar ou manipular dados não autorizados.
                    </Paragraph>

                    <Title level={3}>4. Direitos Autorais</Title>
                    <Paragraph>
                        Todo o conteúdo exibido no aplicativo, incluindo logotipos, textos e imagens, é protegido por direitos autorais e pertence aos seus respectivos proprietários.
                    </Paragraph>

                    <Title level={3}>5. Modificações no Serviço</Title>
                    <Paragraph>
                        Podemos atualizar, suspender ou interromper funcionalidades do aplicativo a qualquer momento, com ou sem aviso prévio.
                    </Paragraph>

                    <Title level={3}>6. Isenção de Garantias</Title>
                    <Paragraph>
                        Embora façamos o possível para manter o serviço funcionando corretamente, não garantimos que ele estará sempre disponível ou livre de erros. A localização e os dados exibidos podem conter imprecisões.
                    </Paragraph>

                    <Title level={3}>7. Alterações nos Termos</Title>
                    <Paragraph>
                        Estes Termos de Uso podem ser atualizados periodicamente. A data da última atualização será sempre exibida no topo da página.
                    </Paragraph>

                    <Title level={3}>8. Contato</Title>
                    <Paragraph>
                        Se você tiver dúvidas ou sugestões sobre estes Termos de Uso, entre em contato pelo e-mail: <a href="mailto:contato@telabite.com">contato@telabite.com</a>.
                    </Paragraph>
                </Typography>
            </Content>
        </Layout>
    );
};

export default TermsOfUse;
